export const SEC_CONTENT = {
  hero: {
    kicker: 'Para empresas com equipe de vendas comissionada',
    title: 'Fim da planilha de comissão e da discussão no fechamento do mês.',
    subtitle:
      'O 77Gestão calcula a comissão de cada vendedor automaticamente, a partir de cada venda realizada — sem planilha, sem divergência e sem depender de ninguém para fechar o mês.',
    cta: 'Quero automatizar a comissão',
    ctaMessage: 'Quero conhecer o sistema de comissão de vendedores do 77Gestão',
    urgency: 'Cada mês que passa com cálculo manual é um mês a mais de erro, retrabalho e vendedor desconfiado do valor recebido.',
  },

  statsStrip: [
    { number: '0', label: 'planilhas de comissão por mês', icon: 'fa-solid fa-file-excel' },
    { number: 'Automático', label: 'cálculo a cada venda fechada', icon: 'fa-solid fa-calculator' },
    { number: '1 carteira', label: 'de clientes por vendedor', icon: 'fa-solid fa-user-tag' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então você sabe que algo precisa mudar.',
    intro:
      'Empresas com equipe de vendas comissionada perdem tempo e credibilidade todo mês por causa de cálculo manual. Não é falta de esforço — é falta da ferramenta certa.',
    items: [
      { icon: 'fa-solid fa-table-cells', text: 'Comissão calculada em planilha, venda por venda, todo fim de mês.' },
      { icon: 'fa-solid fa-scale-unbalanced', text: 'O vendedor acha que vai receber um valor e o financeiro calcula outro — e a discussão trava o fechamento.' },
      { icon: 'fa-solid fa-users-rectangle', text: 'Dois vendedores atendendo o mesmo cliente, brigando por quem tem direito à comissão.' },
      { icon: 'fa-regular fa-clock', text: 'Dias perdidos conferindo venda por venda antes de liberar o pagamento da equipe.' },
      { icon: 'fa-solid fa-chart-simple', text: 'Sem visibilidade real de quem vende mais, quem vende menos e por quê.' },
    ],
  },

  midCta: {
    text: 'E se cada venda já saísse com a comissão calculada, sem você ou o financeiro terem que mexer em nada?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de comissão de vendedores do 77Gestão',
  },

  solution: {
    title: 'A comissão certa, calculada sozinha, a partir de cada venda.',
    intro:
      'O 77Gestão conecta vendas, vendedores e financeiro em um único fluxo — a comissão deixa de ser uma tarefa manual e passa a ser uma consequência automática da venda.',
    cards: [
      {
        icon: 'fa-solid fa-calculator',
        title: 'Cálculo automático por venda',
        text: 'Assim que a venda é fechada, o sistema já calcula a comissão do vendedor responsável. Sem planilha, sem conferência manual.',
      },
      {
        icon: 'fa-solid fa-user-lock',
        title: 'Carteira de clientes por vendedor',
        text: 'Cada vendedor tem sua carteira de clientes vinculada no sistema, evitando que mais de uma pessoa dispute a mesma venda.',
      },
      {
        icon: 'fa-solid fa-chart-line',
        title: 'Relatório de performance por vendedor',
        text: 'Veja quem vende mais, qual o ticket médio e quanto cada vendedor gerou de comissão no período — sem montar relatório manual.',
      },
      {
        icon: 'fa-solid fa-file-signature',
        title: 'Da proposta à venda comissionada',
        text: 'Propostas comerciais aprovadas viram venda automaticamente, já com o vendedor e a comissão corretos vinculados.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Comissão integrada ao financeiro',
        text: 'O valor calculado entra direto no financeiro, sem lançamento manual e sem risco de esquecer de pagar alguém.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a comissão para de ser um problema mensal',
    intro:
      'Uma empresa com 8 vendedores fechava a comissão em uma planilha compartilhada. Todo mês havia pelo menos uma divergência que gerava discussão e atrasava o pagamento da equipe.',
    stats: [
      { number: '0', label: 'divergências de cálculo após o sistema' },
      { number: '5x', label: 'mais rápido para fechar a comissão do mês' },
      { number: '1', label: 'carteira de clientes por vendedor, sem conflito' },
    ],
    paragraphs: [
      'Depois da implantação, cada venda já saiu do sistema com a comissão calculada e vinculada ao vendedor certo, sem intervenção manual do financeiro.',
      'O que antes levava dias de conferência passou a ser conferido em minutos — e a equipe de vendas parou de questionar o valor recebido, porque o cálculo é o mesmo para todo mundo.',
    ],
    highlight: 'Resultado: comissão sem discussão, fechamento mais rápido e equipe de vendas mais confiante.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como automatizar a comissão de vendedores no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão da comissão',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Comissão de cada vendedor, de cada venda, disponível a qualquer momento — não só no fechamento do mês.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Carteira de clientes definida por vendedor e cálculo automático evitam conflito e erro de cálculo.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'O vendedor sabe, venda a venda, quanto está gerando de comissão — sem surpresa no fim do mês.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para gerir a comissão da equipe',
    items: [
      { icon: 'fa-solid fa-link', text: 'Comissão integrada a vendas, propostas e financeiro — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-puzzle-piece', text: 'Regras de comissão adaptáveis ao tamanho e ao modelo da sua equipe de vendas.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe começa a usar com a regra de comissão já configurada.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Cada vendedor tem uma regra de comissão diferente. O sistema aguenta?',
        answer:
          'Sim. As regras de comissão são configuráveis por vendedor, permitindo tratar percentuais e condições diferentes dentro da mesma empresa.',
      },
      {
        question: 'E se dois vendedores atenderem o mesmo cliente?',
        answer:
          'A carteira de clientes é vinculada a cada vendedor dentro do sistema, o que evita que mais de uma pessoa dispute a comissão da mesma venda.',
      },
      {
        question: 'O vendedor consegue ver quanto vai receber?',
        answer:
          'Sim. A comissão é calculada assim que a venda é registrada, dando visibilidade imediata do valor gerado por cada negociação.',
      },
      {
        question: 'Minha equipe é pequena. Vale a pena mesmo assim?',
        answer:
          'Vale. Mesmo com poucos vendedores, o cálculo manual consome tempo e gera atrito. O sistema elimina isso desde o primeiro mês de uso.',
      },
      {
        question: 'Preciso trocar todo o meu sistema de vendas para usar isso?',
        answer:
          'Não. O módulo de comissão faz parte do 77Gestão, já integrado a vendas, propostas e financeiro — não é uma ferramenta separada para conciliar depois.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de calcular comissão na mão. Deixe o sistema fazer isso por você.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como o 77Gestão calcula a comissão de cada vendedor automaticamente, sem planilha e sem discussão no fechamento.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de comissão de vendedores do 77Gestão',
  },

  seo: {
    title: 'Sistema de Cálculo de Comissão de Vendedores | 77Gestão',
    description:
      'Software de comissão de vendedores com cálculo automático a partir de cada venda, carteira por vendedor e relatório de performance. Agende uma demonstração.',
  },
};
